<template>
  <div class="integracoes-list">
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <h2>Integrações Bancárias</h2>
      <b-button
        variant="success"
        @click="addNew()"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-50"
        />
        Nova Integração
      </b-button>
    </div>

    <b-card>
      <b-table
        responsive
        :items="gateways"
        :fields="fields"
        class="mb-0"
        show-empty
        empty-text="Nenhuma integração configurada"
      >
        <template #cell(provedor)="data">
          <b-badge :variant="getProviderVariant(data.value)">
            {{ data.value }}
          </b-badge>
        </template>

        <template #cell(ambiente)="data">
          <b-badge :variant="data.value === 'PRODUCAO' ? 'danger' : 'warning'">
            {{ data.value }}
          </b-badge>
        </template>

        <template #cell(ativo)="data">
          <feather-icon
            :icon="data.value ? 'CheckCircleIcon' : 'XCircleIcon'"
            :class="data.value ? 'text-success' : 'text-danger'"
          />
        </template>

        <template #cell(actions)="data">
          <div class="d-flex align-items-center">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
              size="sm"
              @click="edit(data.item)"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
              />
              <span>Editar</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="flat-danger"
              size="sm"
              @click="confirmDelete(data.item)"
            >
              <feather-icon
                icon="TrashIcon"
                class="mr-50"
              />
              <span>Excluir</span>
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BButton, BBadge,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import mixinsGlobal from '@/mixins'

export default {
  name: 'IntegracaoGatewayList',
  components: {
    BCard, BTable, BButton, BBadge,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      fields: [
        { key: 'descricao', label: 'Descrição', sortable: true },
        { key: 'provedor', label: 'Provedor', sortable: true },
        { key: 'ambiente', label: 'Ambiente', sortable: true },
        { key: 'ativo', label: 'Status', class: 'text-center' },
        { key: 'actions', label: 'Ações', class: 'text-center' },
      ],
    }
  },
  computed: {
    ...mapState('bankIntegrationModule', ['gateways']),
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$store.dispatch('bankIntegrationModule/loadAll')
    },
    addNew() {
      this.$store.dispatch('bankIntegrationModule/reset')
      this.$router.push({ name: 'integracoes-add' })
    },
    edit(item) {
      this.$store.dispatch('bankIntegrationModule/loadById', item.id)
      this.$router.push({ name: 'integracoes-edit', params: { id: item.id } })
    },
    confirmDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir esta configuração? Isso pode afetar as contas vinculadas.', {
          title: 'Confirmar Exclusão',
          okVariant: 'danger',
          okTitle: 'Sim, Excluir',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-secondary',
        })
        .then(value => {
          if (value) {
            this.handleDelete(item.id)
          }
        })
    },
    async handleDelete(id) {
      try {
        await this.$store.dispatch('bankIntegrationModule/delete', id)
        this.showMessageSuccess('Sucesso', 'Configuração excluída com sucesso.')
      } catch (e) {
        this.MensagemError('Erro', 'Não foi possível excluir a configuração.')
      }
    },
    getProviderVariant(provider) {
      switch (provider) {
        case 'CORA': return 'info'
        case 'PAGBANK': return 'success'
        case 'SANTANDER': return 'primary'
        default: return 'secondary'
      }
    },
  },
}
</script>

<style scoped>
.integracoes-list {
  padding: 1rem 0;
}
</style>
